import { Component, OnInit } from "@angular/core";
import { AuthService } from "src/app/shared/services/auth/auth.service";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { NgForm, FormsModule } from "@angular/forms";
declare var jQuery: any;
import * as moment from "moment";

@Component({
  selector: "app-edit-profile",
  templateUrl: "./edit-profile.component.html",
  styleUrls: ["./edit-profile.component.scss"],
})
export class EditProfileComponent implements OnInit {
  is_authenticate_user: boolean = false;
  profileRequest: any = {};
  profileError: any;
  profileSuccess: any;
  user: any = "";
  image_url_preview: any;
  today = new Date();
  autologinRequest: any = {};
  public min: Date = new Date(1900, 1, 1, 12, 30);

  constructor(public authService: AuthService, private router: Router) {}

  ngOnInit() {
    this.authService.$user.subscribe((data) => {
      if (data) {
        console.log("login chhhhe j");
        console.log(data);
        this.user = data;
        console.log(this.user);
        this.autologinRequest = {
          devices_id: new Date().getTime(),
          devices_name: navigator.userAgent,
          app_version: 1,
          devices_type: "Web",
          os: "Android10",
          // device_token: navigator.userAgent,
        };
        this.checkautoLogin();
        this.profileRequest = {
          phone_number: this.user.phone_number,
          email: this.user.email,
          first_name: this.user.first_name,
          last_name: this.user.last_name,
          birth_date: this.user.birth_date,
        };
      } else {
        this.user = null;
        console.log("login nathi");
      }
    });

    if (this.authService.isLoggedIn == true) {
      this.is_authenticate_user = true;
    } else {
      this.router.navigate(["/singin"]);
    }
  }
  setProfilePic($event) {
    if ($event.target.files.length > 0) {
      let fileToLoad = (this.profileRequest.image = $event.target.files[0]);

      var reader: FileReader = new FileReader();
      reader.onloadend = (readerEvt: any) => {
        this.image_url_preview = readerEvt.target.result;
      };
      reader.readAsDataURL(fileToLoad);
      this.image_url_preview = $event.target.files;
    }
  }

  Updateprofile(form: NgForm) {
    if (form.valid) {
      this.profileRequest.birth_date = moment(
        this.profileRequest.birth_date
      ).format("YYYY-MM-DD");
      let request: any = {};
      request = Object.assign({}, this.profileRequest);
      //console.log(request);
      this.authService
        .updateProfile(request)
        .then((res) => {
          //console.log(res.message);
          if (res.status == 0) {
            this.profileError = res.message;
          } else {
            this.checkautoLogin();

            this.profileSuccess = res.message;
            //jQuery.magnificPopup.close();
          }
        })
        .catch((err) => {
          this.profileError = err.error.message;
        });
    }
  }
  uploadfunc() {
    jQuery("#pic_input").trigger("click");
  }
  checkautoLogin() {
    let request: any = {};
    request = Object.assign({}, this.autologinRequest);
    this.authService
      .autologin(request)
      .then((res) => {
        if (res.status == 0) {
          this.logout();
        }
        if (res.status == 1) {
          this.profileRequest.first_name = res.data.first_name;
          this.profileRequest.last_name = res.data.last_name;
          this.profileRequest.email = res.data.email;
          this.profileRequest.phone_number = res.data.phone_number;
          this.profileRequest.birth_date = res.data.birth_date;
          this.profileRequest.image = res.data.image;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  logout() {
    this.authService
      .logout()
      .then(() => {
        this.router.navigate(["/home"]);
      })
      .catch((err) => {
        //console.log(err);
      });
  }
}
